import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children }) => (
  <p className="font-mono text-[11px] sm:text-xs uppercase tracking-[0.3em] text-lime flex items-center gap-3">
    <span className="pulse-dot inline-block h-2 w-2 rounded-full bg-lime" />
    {children}
  </p>
);

export default Reveal;
